import Model from 'flarum/common/Model';
export default class Friendship extends Model {
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  user = (() => Model.hasOne('user'))();
  friend = (() => Model.hasOne('friend'))();
}
flarum.reg.add('forumaker-friendship', 'common/models/Friendship', Friendship);